import React, { useState } from "react";
import communityArt from "../../../assets/homepage1/community-art.png";

export const CommunitySection: React.FC = () => {
  const [subscribeInput, setSubscribeInput] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!subscribeInput.trim()) return;
    setSubmitted(true);
    setTimeout(() => {
      setSubscribeInput("");
      setSubmitted(false);
    }, 4000);
  };

  return (
    <section className="homepage1-comm-section">
      <div className="homepage1-comm-container">
        {/* Left: Text & Subscribe */}
        <div className="homepage1-comm-left">
          <span className="homepage1-section-tag">
            Ecosystem Guild &amp; Community
          </span>
          <h3 className="homepage1-comm-heading">
            Join 1.2M+ Builders, Traders &amp; Visionaries
          </h3>
          <p className="homepage1-comm-desc">
            Stay synchronized with weekly protocol releases, AI inference
            benchmarks, jackpot distributions, and treasury allocation reports.
          </p>

          <form className="homepage1-comm-form" onSubmit={handleSubmit}>
            <input
              type="text"
              className="homepage1-comm-input"
              placeholder="Enter your email or 0x address..."
              value={subscribeInput}
              onChange={(e) => setSubscribeInput(e.target.value)}
            />
            <button type="submit" className="homepage1-comm-submit">
              Get Updates
            </button>
          </form>

          {submitted && (
            <div className="homepage1-comm-success">
              ✓ Subscribed successfully. Welcome to the indexx.ai guild!
            </div>
          )}

          {/* Social Media Links */}
          <div className="homepage1-social-cluster">
            <a
              href="https://twitter.com/indexx_ai"
              target="_blank"
              rel="noopener noreferrer"
              className="homepage1-social-btn"
              title="X / Twitter"
            >
              <span className="font-mono font-bold text-xs">𝕏</span>
            </a>
            <a
              href="https://t.me/indexx_ai"
              target="_blank"
              rel="noopener noreferrer"
              className="homepage1-social-btn"
              title="Telegram"
            >
              <span className="material-symbols-outlined text-base">send</span>
            </a>
            <a
              href="https://youtube.com/@indexx_ai"
              target="_blank"
              rel="noopener noreferrer"
              className="homepage1-social-btn"
              title="YouTube"
            >
              <span className="material-symbols-outlined text-base">
                smart_display
              </span>
            </a>
            <a
              href="https://discord.gg/indexx"
              target="_blank"
              rel="noopener noreferrer"
              className="homepage1-social-btn"
              title="Community Discord"
            >
              <span className="material-symbols-outlined text-base">
                group
              </span>
            </a>
          </div>
        </div>

        {/* Right: Artwork */}
        <div className="homepage1-comm-art-wrapper">
          <div className="homepage1-comm-art-card">
            <img
              src={communityArt}
              alt="indexx community artwork"
              className="homepage1-comm-art-img"
              onError={(e) => {
                (e.target as HTMLImageElement).src =
                  "https://lh3.googleusercontent.com/aida-public/AB6AXuCawmvfFJCHp_2XBS_GoGT5KuLfsoNjSaSoZc0RIp-f_Qhy2jEm9M5e3V_DDCU6F2we0m5-Ok3QLfL4cq2M--EmJbZt2qdm-RxQQXL2ZvkuhtyWNiARgDbLzE_6DGOmYGHPIUhqqC64uBWgJGl6JZTYj_fX8cKcJbxr6UpujSonXYCCBaXwtZkRYQOwwycZCAH5wQzb7DkNRoJfV2YX4YUL4WCmGfhfBlGfL0hOY4CfgIZlTkGf_b7KLg";
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
